import { useEffect } from "react";
import { useSelect } from "@pankod/refine-core";
import {
  Checkbox,
  Grid,
  Hidden,
  TextField,
  Typography,
} from "@pankod/refine-mui";
import { useState } from "react";
import { toast } from "react-toastify";

import AutoGeneratedInputCmp from "../../components/auto-generated-input/AutoGeneratedInputCmp";
import SimpleUploadZone from "../../components/SimpleUploadZone";

export default function CompFields({
  register,
  errors,
  control,
  getValues,
  setValue,
  isSeller,
  record,
  user,
}) {
  const [businessView, setBusinessView] = useState();
  const [loaded, setLoaded] = useState(false);

  const { options: municipalities } = useSelect({
    resource: "municipalities",
    optionLabel: "name",
    optionValue: "id",
  });

  const { options: user_categories } = useSelect({
    resource: "user-categories",
    optionLabel: "name",
    optionValue: "id",
  });

  // base fields
  const fields = [
    {
      label: "Nome",
      name: "first_name",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Cognome",
      name: "last_name",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Azienda",
      name: "company",
      required: true,
      type: "text",
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "P.IVA",
      name: "vat",
      required: true,
      type: "text",
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "Indirizzo",
      name: "address",
      required: true,
      type: "text",
      md: 12,
      style: { marginBottom: "20px" },
    },

    {
      label: "Comune",
      name: "municipality",
      required: true,
      type: "select",
      options: municipalities,
      md: 6,
    },
    {
      label: "Città",
      name: "city",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "CAP",
      name: "zip_code",
      required: true,
      type: "number",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Telefono",
      name: "phone",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Email",
      name: "email",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Categoria",
      name: "user_category",
      required: true,
      type: "select",
      options: user_categories,
      md: 6,
    },
  ];

  useEffect(() => {
    if (record) {
      setValue("first_name", record.first_name);
      setValue("last_name", record.last_name);
      setValue("company", record.company);
      setValue("vat", record.vat);
      setValue("address", record.address);
      setValue("city", record.city);
      setValue("zip_code", record.zip_code);
      setValue("phone", record.phone);
      setValue("email", record.email);
      // if we can edit this we set the id
      if (record.municipality) {
        if (
          user?.role?.name === "Muincipality" ||
          user?.role?.name === "Admin"
        ) {
          setValue("municipality", record.municipality.id);
          setValue("user_category", record.user_category.id);
        } else {
          setValue("municipality", record.municipality.name);
          setValue("user_category", record.user_category.name);
        }
      }
      setLoaded(true);
    }
  }, [user, getValues, record, setValue]);

  return (
    <Grid item xs={12}>
      {!loaded && (
        <Grid
          container
          spacing={2}
          style={{ padding: "30px" }}
          justifyContent="center"
        >
          <Typography variant="h4">Caricamento...</Typography>
        </Grid>
      )}
      {loaded && (
        <Grid container spacing={2} style={{ padding: "30px" }}>
          {fields.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                {...field}
                register={register}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
                viewMode={
                  user?.role?.name !== "Muincipality" &&
                  user?.role?.name !== "Admin"
                }
              />
            );
          })}
          <Hidden>
            <TextField
              {...register("status")}
              hidden
              required={true}
              defaultValue="submitted"
              type="text"
              style={{ height: "0", display: "none" }}
            />
            <Checkbox
              {...register("is_seller")}
              checked={isSeller}
              type="checkbox"
              style={{ height: "0", display: "none" }}
            />
            <Checkbox
              {...register("accepted_tos")}
              checked={true}
              type="checkbox"
              style={{ height: "0", display: "none" }}
            />
          </Hidden>
        </Grid>
      )}
      {(user?.role?.name === "Muincipality" ||
        user?.role?.name === "Admin") && (
        <Grid
          container
          spacing={2}
          style={{ padding: "30px" }}
          justifyContent="start"
          gap={4}
          alignItems="center"
        >
          <Typography variant="h6">Visura Camerale</Typography>

          <SimpleUploadZone
            label="Aggiungi"
            onChange={async (file) => {
              // await axios.post("/api/upload", {
              //   data: {
              //     name: "visura_camerale",
              //     attachment: file.id,
              //     alternativeText: "submitted",
              //     caption: "prova",
              //   },
              // });
              toast.success("Documento caricato con successo");
              setValue("business_view", file.id);
              setBusinessView(file.id);

              // await new Promise((resolve) => setTimeout(resolve, 1000));
              // window.location.reload();
            }}
          />
        </Grid>
      )}
    </Grid>
  );
}
